/*
* @TagTable.vue
* @Description 标签管理组件
* @Author jsh
* @Date 2021/6/28
*/
<template>
  <div class="table-item-box _padding-l-none" style="padding: 10px;">
    <section style="height: 100%;">

      <!-- 表格 -->
      <el-table :data="tagInfos"
                @sort-change="changeSort"
                ref="multipleTable"
                stripe
                @row-click="rowHandle"
                :class="{'table': true, 'no-pagination': false}">
        <el-table-column type="selection" :selectable="checkSelectable"/>
        <el-table-column label="标签编号" min-width="150px" :sortable="filters.sortable" prop="did" :sort-orders="filters.sortOrders">
          <template v-slot="scope">
                    <span style="white-space: nowrap;cursor: pointer;" :title="scope.row.did">
                        {{scope.row.did }}
                    </span>
          </template>
        </el-table-column>
        <el-table-column label="流量卡号" min-width="150px">
          <template v-slot="scope">
            <span style="white-space: nowrap;" :title="scope.row.iccid">{{scope.row.iccid}}</span>
          </template>
        </el-table-column>
        <el-table-column label="软件版本" min-width="80px">
          <template v-slot="scope">
            <span style="white-space: nowrap;" :title="scope.row.versionSoft">{{scope.row.versionSoft}}</span>
          </template>
        </el-table-column>
        <el-table-column label="硬件版本" min-width="80px">
          <template v-slot="scope">
            <span style="white-space: nowrap;" :title="scope.row.versionHard">{{scope.row.versionHard}}</span>
          </template>
        </el-table-column>
        <el-table-column label="电量" min-width="80px">
          <template v-slot="scope">
            <span style="white-space: nowrap;" :title="scope.row.battery">{{scope.row.battery + '%'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="绑定状态" min-width="100px">
          <template v-slot="scope">
            <span style="white-space: nowrap;" :title="bindingStatus[scope.row.bindType]">{{bindingStatus[scope.row.bindType]}}</span>
          </template>
        </el-table-column>
        <el-table-column label="绑定名称" min-width="100px">
          <template v-slot="scope">
            <span style="white-space: nowrap;" :title="scope.row.bindName">{{scope.row.bindName}}</span>
          </template>
        </el-table-column>
      </el-table>

      <!--分页工具条-->
      <Pagination
          :currentPage="pagination.currentPage"
          :total="pagination.total"
          :pageSize="pagination.limit"
          @handleSizeChangeSub="handleSizeChangeSub"
          @handleCurrentChangeSub="handleCurrentChangeSub"
      />

      <!--查询工具条-->
      <el-col style="text-align: left;">
        <el-form :inline="true" :model="filters" ref="filters">
          <el-form-item>查询条件：</el-form-item>
          <el-form-item prop="keyword">
            <el-input v-model="filters.keyword" placeholder="请输入标签编号" clearable @keyup.enter.native="researchTag" :style="{width: '300px'}">
              <i slot="suffix" class="el-input__icon el-icon-search" @click="researchTag"></i>
            </el-input>
          </el-form-item>
          <el-form-item style="position: absolute;top: 9px;right: 20px;margin: 0;z-index: 3;">
            <el-dropdown split-button type="primary"  @click="deleteRows" trigger="click" size="mini">
              <i class="el-icon-delete"></i> 批量删除
              <el-dropdown-menu slot="dropdown" trigger="click">
                <el-dropdown-item icon="el-icon-download" @click.native="searchExportData">批量导出</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
        </el-form>
      </el-col>


      <!-- ======================= 导出所需数据 =============================== -->
      <el-table :data="exportDatas"  id="out-table" stripe  style="display: none;" class="table">
        <el-table-column label="标签编号">
          <template v-slot="scope">
            {{scope.row.did}}
          </template>
        </el-table-column>
        <el-table-column label="流量卡号">
          <template v-slot="scope">
            {{scope.row.iccid}}
          </template>
        </el-table-column>
        <el-table-column label="软件版本">
          <template v-slot="scope">
            {{scope.row.versionSoft}}
          </template>
        </el-table-column>
        <el-table-column label="硬件版本">
          <template v-slot="scope">
            {{scope.row.versionHard}}
          </template>
        </el-table-column>
        <el-table-column label="电量">
          <template v-slot="scope">
            {{scope.row.battery + '%'}}
          </template>
        </el-table-column>
        <el-table-column label="绑定状态">
          <template v-slot="scope">
            {{bindingStatus[scope.row.bindType]}}
          </template>
        </el-table-column>
        <el-table-column label="绑定名称">
          <template v-slot="scope">
            {{scope.row.bindName}}
          </template>
        </el-table-column>
        <el-table-column label="位置">
          <template v-slot="scope">
            {{scope.row.address}}
          </template>
        </el-table-column>
      </el-table>

    </section>
  </div>

</template>

<script>
// API oam
import ApiOam from '@/request/api-oam'
// 分页组件
import Pagination from '@/components/Pagination.vue'
// 公共函数
import GlobalFun from "@/global/global-function";

export default {
  name: "GNSSTagTable",
  /**
   * @Des 组件引用
   * @Auth jsh
   * @Date 09:41 2021/6/28
   */
  components: {
    // 分页工具
    Pagination
  },
  /**
   * @Des 数据定义
   * @Auth jsh
   * @Date 09:41 2021/6/28
   */
  data() {
    return {
      /**
       * @Des 查询条件属性
       * @Auth jsh
       * @Date 09:41 2021/6/28
       */
      filters: {
        projectId: this.$store.state.currentProjectId,
        projectName: this.$store.state.currentProjectName,
        keyword: '',
        status: '',
        orderBy: {
          "bind_type": 'desc',
          'bind_name': 'asc',
          "did": "asc"
        },
        sortOrders: [
          "ascending",
          "descending"
        ],
        sortable: 'custom',
      },
      // 基站集合
      tagInfos:[],
      exportDatas: [],
      projectInfos: {},
      areas: {},
      maps: {},
      bsGroups: {},
      locked: false,
      bindingStatus: {
        0: '未绑定',
        1: '绑定人',
        2: '绑定发动机',
        3: '绑定车'
      },
      /**
       * @Des 分页数据
       * @Auth
       * @Date 2021/6/4
       */
      pagination:{
        total: 0,
        startNum: 0,
        limit: 50,
        currentPage: 1
      },
    }
  },
  computed: {
  },
  created(){
    this.searchTag();
  },
  mounted(){
  },
  /**
   * @Des 方法定义
   * @Auth jsh
   * @Date 09:42 2021/6/28
   */
  methods: {

    /**
     * @Des 查询基站
     * @Auth jsh
     * @Date 09:42 2021/6/28
     */
    searchTag() {
      this.$request.postJsonRequest(ApiOam.Search_GNSS_Tag_Uri, {
        projectId: this.filters.projectId,
        keyword: this.filters.keyword,
        orderBy: this.filters.orderBy,
        total: this.pagination.total,
        startNum: this.pagination.startNum,
        limit: this.pagination.limit,
      }).then(result => {
        console.log(result)
        this.tagInfos = [];
        this.pagination.total = result.total;
        if(result.total > 0){
          result.rows.forEach((row, index) => {
            this.tagInfos.push(row);
          });
        }
        // console.log(this.bsInfos)
      }).catch(error => {
        console.error('查询标签异常', ApiOam.Search_Uwb_Tag_Uri, error);
      })
    },

    /**
     * 是否选择
     * */
    checkSelectable(row){
      return true;
    },
    /**
     * 重新搜索
     * */
    researchTag(){
      this.pagination.total = 0;
      this.pagination.startNum = 0;
      this.pagination.currentPage = 1;
      this.searchTag();
    },
    /**
     * 改变排序
     * */
    changeSort(data){
      let prop = data.prop;
      let order = data.order;
      if(order == null){
        order = this.filters.orderBy[prop];
      }else{
        order = order.replace("ending", "");
      }
      if(order == null){
        this.filters.orderBy["sid"] = "asc";
      }else{
        this.filters.orderBy = {};
        this.filters.orderBy[prop] = order;
      }
      this.researchTag();
    },

    /**
     * @Des 当前页数据改变
     * @Auth
     * @Date 2021/6/4
     */
    handleCurrentChangeSub(val){
      this.pagination.currentPage = val;
      this.pagination.startNum = this.pagination.limit * (val-1);
      this.searchTag();
    },
    /**
     * @Des 页长度改变
     * @Auth
     * @Date 2021/6/4
     */
    handleSizeChangeSub(val){
      this.pagination.limit = val;
      this.pagination.currentPage = 1;
      this.pagination.startNum = 0;
      this.searchTag();
    },

    /**
     * 删除行
     * @param row
     */
    deleteRow(row){
      this.$confirm(
          '确认删除标签：'+ row.did + '）吗？','询问',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal : false,
            type: 'warning'
          }
      ).then(_ => {
        let param = {
          sids: [row.sid]
        };
        this.delete(param);
      });
    },
    /**
     * 删除多行
     * @param row
     */
    deleteRows(){
      let selection = this.$refs.multipleTable.selection;
      if(selection.length == 0){
        this.$message({
          message: '请选择要删除的数据',
          type: 'info',
          showClose: true,
          dangerouslyUseHTMLString: true
        });
        return false;
      }
      let sids = [];
      selection.forEach((row, index) => {
        if(row.bindType == 0){
          sids.push(row.did);
        }
      });
      console.log(sids.length)
      if(sids.length == 0){
        this.$message({
          message: '请选择未绑定的标签',
          type: 'info',
          showClose: true,
          dangerouslyUseHTMLString: true
        });
        return false;
      }
      this.$confirm(
          '确认批量删除选中的未绑定的标签信息吗？','询问',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal : false,
            type: 'warning'
          }
      ).then(_ => {
        let param = {
          dids: sids
        };
        this.delete(param);
      });

    },
    delete(param){
      if(this.locked) return;
      this.locked = true;
      this.$request.postJsonRequest(ApiOam.Delete_GNSS_Tag_Uri, param).then(result => {
        // console.log(result.code);
        if(result.code == 0){
          this.$message({
            message: '删除成功',
            type: 'success',
            showClose: true,
            dangerouslyUseHTMLString: true
          });
        }else{
          this.$message({
            message: result.msg,
            type: 'error',
            showClose: true,
            dangerouslyUseHTMLString: true
          });
        }
        this.locked = false;
        this.researchTag();
      }).catch(error => {
        this.locked = false;
        console.error('删除标签异常', ApiOam.Delete_Uwb_Tag_Uri, error);
      })
    },
    /**
     * 处理行
     * @param row
     */
    rowHandle(row){
      if(row.checked){
        row.checked = false;
      }else{
        row.checked = true;
      }
      this.$refs.multipleTable.toggleRowSelection(row, row.checked)
    },

    /**
     * @Des 查询导出数据
     * @Auth jsh
     * @Date 11:45 2021/7/3
     */
    searchExportData() {
      this.$request.postJsonRequest(ApiOam.Search_GNSS_Tag_Uri, {
        projectId: this.filters.projectId,
        keyword: this.filters.keyword,
        orderBy: this.filters.orderBy,
        total: 0,
        startNum: 0,
        limit: 0,
      }).then(result => {
        this.exportDatas = Object.assign([], []);
        if(result.total > 0){
          result.rows.forEach((row, index) => {
            this.exportDatas.push(row);
          });
        }
        this.$nextTick(()=>{
          GlobalFun.exportExcel(document.querySelector("#out-table"),'GNSS标签信息.xlsx');
        })
      }).catch(error => {
        console.error('导出标签异常', ApiOam.Search_GNSS_Tag_Uri, error);
      })
    },

  },


}
</script>

/* CSS */
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components_pages/Device/GNSSTagTable.vue